'use strict';

module.exports = paragraph;

function paragraph(node) {
  return this.all(node).join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/paragraph.js
// module id = 977
// module chunks = 95715928098905 168707334958949